export default __webpack_public_path__ + "static/media/FFGoodHeadline-Regular.fc5784ae.otf";